import { useEffect } from "react";
import BienvenueBloc from "../blocs/bienvenue/BienvenueBloc";
import { scroll2Top } from "../utils/utils";

export default function BienvenuePage() {
    
  useEffect(() => {scroll2Top();}, []);

    return (
      <div className="entreprise-container">
        <div className="ta-center m-y-sm">
          <h2 className="fw-medium bleu fz-xl">Bienvenue sur votre parcours d’affiliation</h2>
          <span className="border-fushia medium m-y-md"></span>
        </div>
        <div className="flex-grid m-lg-desktop">
          <BienvenueBloc/>
        </div> 
      </div>
    )

}